// extracted by mini-css-extract-plugin
module.exports = {"Industry":"index-module_Industry_1n5jz"};